module.exports = __webpack_public_path__ + "img/ImgQRCode.add10aef.png";